export default __webpack_public_path__ + "static/pexels-pixabay-180d70d7a83a66cf8a2cb2c0545aa962.png";